import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { KYBFilters } from "interfaces/router";

export interface AllKYBFilters extends KYBFilters {
  searchColumn: string;
  searchTerm: string;
}

export interface OnboardingsPagination {
  page: number;
  page_size: number;
}

export interface OnboardingsSort {
  sort_by: string;
  sort_dir: "asc" | "desc";
}

export interface AdminOnboardingsState {
  filters: AllKYBFilters;
  pagination: OnboardingsPagination;
  sort: OnboardingsSort;
}

const defaultFilters: AllKYBFilters = {
  status: undefined,
  analyst: undefined,
  decider: undefined,
  broker: undefined,
  searchColumn: "company_name",
  searchTerm: "",
};

const defaultPagination: OnboardingsPagination = {
  page: 1,
  page_size: 50,
};

const defaultSort: OnboardingsSort = {
  sort_by: "time_created",
  sort_dir: "desc",
};

const initialState: AdminOnboardingsState = {
  filters: { ...defaultFilters },
  pagination: { ...defaultPagination },
  sort: { ...defaultSort },
};

export const adminOnboardingsSlice = createSlice({
  name: "adminOnboardings",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<AllKYBFilters>>) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
      state.pagination.page = 1;
    },
    setPagination: (
      state,
      action: PayloadAction<Partial<OnboardingsPagination>>,
    ) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      };
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.pagination.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.page_size = action.payload;
      state.pagination.page = 1;
    },
    setSort: (state, action: PayloadAction<OnboardingsSort>) => {
      state.sort = action.payload;
    },
    resetFilters: (state) => {
      state.filters = { ...defaultFilters };
      state.pagination = { ...defaultPagination };
    },
  },
});

export const {
  setFilters,
  setPagination,
  setPage,
  setPageSize,
  setSort,
  resetFilters,
} = adminOnboardingsSlice.actions;

export default adminOnboardingsSlice.reducer;
